import { defineMessages } from 'react-intl'

export default defineMessages({
  callToAction: { defaultMessage: 'Talk with us' },
})
